import MuiTextField, { TextFieldProps } from '@mui/material/TextField';
import React from 'react';
import { styled } from '@mui/material/styles';

interface Props {}

const StyledTextField = styled(MuiTextField)`
  & .MuiOutlinedInput-root {
    background-color: var(--olymp-robot-surface, #243247);
    & fieldset {
      border: 1px solid transparent;
    }
    &:hover fieldset {
      border: 2px solid var(--olymp-robot-primary, #0094ff);
    }
  }

  & input:autofill {
    -webkit-box-shadow: unset !important;
  }

  & input {
    box-sizing: border-box;
    height: inherit;
  }

  caret-color: var(--olymp-robot-primary, #0094ff);
`;
const TextField: React.FC<Props & TextFieldProps> = React.forwardRef((props, ref) => {
  const { className } = props;
  return <StyledTextField ref={ref} className={className} {...props} />;
});

TextField.displayName = 'TextField';

export default React.memo(TextField);
